// Add an item to selectized input and select it
var selectizeAddNewSelectedItem = function( selectizedInput, value, name ) {
    selectizedInput = selectizedInput[0].selectize;

    selectizedInput.clear( true );
    selectizedInput.refreshItems();

    selectizedInput.addOption(
        {
            text: name,
            value: value,
        }
    );
    selectizedInput.refreshOptions();

    selectizedInput.addItem( value );
    selectizedInput.refreshItems();
}

// Rename the currently selected item in selectized input
var selectizeRenameCurrentlySelectedItem = function( selectizedInput, name ) {
    let value = selectizedInput.val();
    selectizedInput = selectizedInput[0].selectize;

    selectizedInput.updateOption(
        value,
        {
            text: name,
            value: value,
        }
    );
}

// Delete the currenlty selected item from selectized input
var selectizeDeleteSelectedItem = function( selectizedInput ) {
    let value = selectizedInput.val();
    selectizedInput = selectizedInput[0].selectize;

    selectizedInput.clear( true );
    selectizedInput.refreshItems();

    selectizedInput.removeOption( value );
    selectizedInput.refreshOptions();
}

// Deselect the currenlty selected item from selectized input
var selectizeClearSelectedItem = function( selectizedInput ) {
    selectizedInput = selectizedInput[0].selectize;

    selectizedInput.clear( true );
    selectizedInput.refreshItems();
}

// Get currenlty selected item from selectized input
var selectizeGetSelectedItemText = function( selectizedInput ) {
    let value = selectizedInput.val();

    return selectizeGetItemText( selectizedInput, value );
}


// Get item text  from selectized input
var selectizeGetItemText = function( selectizedInput, value ) {
    selectizedInput = selectizedInput[0].selectize;

    return selectizedInput.options[value].text;
}

// Clear all options from selectized input
var selectizeClearOptions = function( selectizedInput ) {
    selectizedInput = selectizedInput[0].selectize;

    selectizedInput.clearOptions( true );
    selectizedInput.refreshOptions();
}

// Add option(s) from selectized input
var selectizeAddOptions = function( selectizedInput, options ) {
    selectizedInput = selectizedInput[0].selectize;

    selectizedInput.addOption( options );
    selectizedInput.refreshOptions();
}


jQuery(function( $ ) {
    "use strict"
    // https://jsfiddle.net/davidhequet/8wke3a23/
    // selectize requires id and text as the element attributes to manage elements
    Vue.component('selectize', {
        props: ['options', 'value'],
        template: '<select><slot></slot></select>',
        mounted: function () {
            var vm = this;
            var defaultOptions = {
                openOnFocus: false,
                closeAfterSelect: true,
            };
            var elementOptions = $.extend({},$(this.$el).data() );
            var opt = Object.assign( defaultOptions, elementOptions );

            if (this.options != null)
                opt.options = this.options;
                this.sel = $(this.$el).selectize(opt)
                    .on("change",function(){
                        vm.$emit('input', vm.sel.getValue());
                    })[0].selectize;
                this.sel.setValue(this.value,true);
            },
        watch: {
            value: function (value) {
                this.sel.setValue(value,true);
            },
            options: function (options) {
                var val = this.sel.getValue();
                this.sel.clearOptions();
                this.sel.addOption(options);
                this.sel.refreshOptions(false);
                this.sel.setValue(val);
                console.log('** Updating Selectize');
                console.log(options);
            }
        },
        destroyed: function () {
            this.sel.destroy();
        }
    });
});
